module.exports = __webpack_public_path__ + "static/Toss-6f90c308af534e4e6806bfd40a0d759e.jpg";